/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ProductFormulationAnnualReportDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    eventType: ProductFormulationAnnualReportDto.eventType;
    readonly performedBy?: ProductFormulationAnnualReportDto.performedBy;
    eventAt: string;
    readonly windowEnd?: string;
};
export namespace ProductFormulationAnnualReportDto {
    export enum eventType {
        EXTENDED = 'EXTENDED',
        NOT_EXTENDED = 'NOT_EXTENDED',
        OVERDUE = 'OVERDUE',
    }
    export enum performedBy {
        SYSTEM = 'SYSTEM',
        MERCEDES_BENZ = 'MERCEDES_BENZ',
        USER = 'USER',
    }
}

